import Vue from "vue";
import Router from "vue-router";
import Layout from "@/pages/layout/index.vue";
import Check from "@/pages/check/index.vue";
import Material from "./view/Material.vue";
import Customer from "./view/Customer.vue";
import Applets from "./view/Applets.vue";
import SignOut from "./view/SignOut.vue";
import Original from "./view/Original.vue";
import HomeIntroduce from "./view/HomeIntroduce.vue";
import pay from "@/pages/pay/index.vue";
import { RouterTools } from "@/common/RouterTools";
import AiCopywriter from "./pages/ai-copywriting/index.vue";
import Workbench from "./pages/workbench/index.vue";
import Writing from "./view/Writing.vue";

Vue.use(Router); //使用插件

export default new Router({
  mode: "history", // 在创建的 router 对象中，如果不配置 mode，就会使用默认的 hash 模式，该模式下会将路径格式化为 #! 开头
  routes: [
    {
      path: "/",
      name: "homeintroduce",
      component: HomeIntroduce,
    },
    {
      path: "/home",
      name: "home",
      component: Layout,
      redirect: RouterTools.pageNames.writing,
      children: [
        {
          path: RouterTools.pagePaths.writing,
          name: RouterTools.pageNames.writing,
          component: Workbench,
        },
        {
          path: "/material",
          name: "material",
          component: Material,
        },
        {
          path: RouterTools.pagePaths.check,
          name: RouterTools.pageNames.check,
          component: Check,
        },
        {
          path: RouterTools.pagePaths.aiCopywriter,
          name: RouterTools.pageNames.aiCopywriter,
          component: AiCopywriter,
        },
        {
          path: RouterTools.pagePaths.pay,
          name: RouterTools.pageNames.pay,
          component: pay,
        },
        {
          path: "/applets",
          name: "applets",
          component: Applets,
        },
        {
          path: "/customer",
          name: "customer",
          component: Customer,
        },
        {
          path: "/signout",
          name: "signout",
          component: SignOut,
        },
        {
          path: "/original",
          name: "original",
          component: Original,
        },
      ],
    },
  ],
});
